import { useState } from "react"
import { HasInvalidated } from "event-definitions"
import { waitForSystemStable } from "lib/wait-for-system-stable"

export function useDisabledUntilInvalidation(invalidation = "*") {
    const [disabled, setDisabled] = useState(false)
    HasInvalidated(invalidation).useEvent(() => waitForSystemStable(100).then(() => setDisabled(false)))
    return [disabled, disable]

    function disable(value = true) {
        setDisabled(value)
    }
}
